const MODAL_RIGHT_CONFIG = {
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-right wide-modal'
};
export default MODAL_RIGHT_CONFIG;
